import React, { useState } from "react";
import { Link } from "gatsby";
import "./projects.css";
import SEO from "../components/seo"
import Layout from "../components/layout"
import Modal from "../components/modal";
// import { 
//   civil_data, 
//   mining_data, 
// } from "../data/projectData";
import energy from "../data/energy";
import heavy from "../data/heavy";
import automotive from "../data/automotive";
import telecom from "../data/telecom";
import water from "../data/water";


const TextBox = (props) => {
  const data = props.data;
  const [clickedIndex, setClickedIndex] = useState();

  const sendDataToModal = () => {
    let maxNumber = data.image_array.length - 1;

    var modal = <Modal 
    startIndex = { 0 }
    imageItems = { data.image_array }
    onClose = { () => setClickedIndex(null) }
    lastImageIndex = { maxNumber }
    />;
    setClickedIndex(modal);
  }

  return(
    <ul>
      <li 
      onClick={sendDataToModal}>
        <div className="text_box">
          <span>
            <div className= 'icon_title'>
              <i className="fas fa-users blue"></i>
              <h3>{data.client}</h3>
            </div>
            <div className= 'icon_title clipboad'>
              <i className="far fa-clipboard blue"></i>
              <h3>{data.title}</h3>
            </div>
          </span>
          <span>
            <img 
              src={data.image_array[0].image} 
              alt="project sample" 
              width="100" 
              height ="80"
            />
          </span>
        </div>
      </li>
      {clickedIndex}
    </ul>
  )
}


export default function Project() {
  return (
    <>
      <Layout useAccentColorForNav={true}>
      <SEO title="Home" />

      <div id="project_container">
        <section className="category_list">
          <ul>
            <li><h2>Categories</h2></li>
            <li><Link to="#civil">civil / architecture</Link></li>
            <li><Link to="#mining">mining / heavy industory</Link></li>
            <li><Link to="#automotive">automotive</Link></li>
            <li><Link to="#water">water</Link></li>
            <li><Link to="#energy">energy</Link></li>
            <li><Link to="#robotics">robotics / automation</Link></li>
            <li><Link to="#telecom">telecommunication</Link></li>
          </ul>
        </section>
        
        <section className="project_list">
          <div id="list_wrapper">
            <h1 id="civil">Projects</h1>
            <div className="list_box">
              <h2>civil /architecture</h2>
              {/* <TextBox data={civil_data.one} /> */}
            </div>
            <div className="border"  id="mining"></div>
            <div className="list_box">
              <h2>mining / heavy industory</h2>
              <TextBox data={heavy.royal} />
              <TextBox data={heavy.ugl} />
              <TextBox data={heavy.yuleba} />
            </div>
            <div className="border" id="automotive"></div>
            <div className="list_box">
              <h2>automotive</h2>
              <TextBox data={automotive.busGroup} />
            </div>
            <div className="border" id="water"></div>
            <div className="list_box">
              <h2>water</h2>
              <TextBox data={water.nubian} />
              <TextBox data={water.glacier} />
              <TextBox data={water.optimos} />
              <TextBox data={water.steamline} />
            </div>
            <div className="border" id="energy"></div>
            <div className="list_box">
              <h2>energy</h2>
              <TextBox data={energy.mpower} />
              <TextBox data={energy.private} />
            </div>
            <div className="border" id="robotics"></div>
            <div className="list_box">
              <h2>robotics / automation</h2>
              {/* <TextBox data={mining_data.one} /> */}
            </div>
            <div className="border" id="telecom"></div>
            <div className="list_box">
              <h2>telecommunication</h2>
              <TextBox data={telecom.productDevelopment} />
            </div>
          </div>
        </section>
      </div>
      </Layout>
    </>
  )
}